import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// This public feedback-web facade has its own CORS policy and sends no identity headers.
export const themeContractBaseQuery = fetchBaseQuery({
  credentials: 'omit',
  timeout: 10000,
});
